import { clsx } from 'clsx';
import { formatDate } from 'utils/time';
import Link from '../Link/Link';
import styles from './Episode.module.scss';

type EpisodeProps = {
  readonly id?: string;
  readonly index: number;
  readonly title: string;
  readonly url: string;
  readonly startDate?: string;
  readonly shortText?: string;
};

export const Episode = ({ id, index, title, url, startDate, shortText }: EpisodeProps) => {
  return (
    <Link
      id={id}
      className={clsx(styles.link, { 'first-teaser': index === 0 })}
      href={url}
      target="_blank"
      noFollow={false}
    >
      <div className={styles.textWrapper}>
        {startDate && <div className={styles.date}>{formatDate(startDate, true)}</div>}
        <h3 className={clsx(styles.headline, { [styles.first]: index === 0 })}>{title}</h3>
        <div className={styles.description}>{shortText}</div>
      </div>
    </Link>
  );
};
